// Copy synced with content.md — keep the two files aligned when editing website text.

export const contact = {
  phone: '9664610782',
  phoneTel: 'tel:9664610782',
  email: 'shingrejitendra4@gmail.com',
  emailMailto: 'mailto:shingrejitendra4@gmail.com',
  emailSecondary: 'shingrejitendra@hjenterprises.co.in',
  emailSecondaryMailto: 'mailto:shingrejitendra@hjenterprises.co.in',
  location: 'Goregaon West, Mumbai',
};

export const hero = {
  brand: 'H.J. Enterprises',
  tagline: 'Finance Solution',
  partner: 'Your Financial Partner – One Platform',
  guidance: 'Right Guidance. Right Financial Solution.',
  closer: 'Right Advice. Right Loan. Brighter Future.',
  intro: 'At H.J. Enterprises, we help individuals, professionals, entrepreneurs, property owners and businesses find suitable financial solutions based on their requirements.',
  introDetail: 'From home loans and property-backed finance to business loans, personal loans, vehicle loans and insurance solutions, we aim to make the financing journey simple, transparent and convenient.',
  callLabel: `Call Us: ${contact.phone}`,
};

export const whyChoose = [
  {
    title: 'Professional Guidance',
    text: 'We understand that every customer\'s financial requirement is different. We help you identify suitable options based on your profile and requirements.',
  },
  {
    title: 'Multiple Financial Solutions',
    text: 'Access multiple categories of loan and insurance solutions through one platform.',
  },
  {
    title: 'End-to-End Assistance',
    text: 'From initial enquiry and documentation to application coordination, we support you throughout the process.',
  },
  {
    title: 'Transparent Process',
    text: 'We believe in clear communication regarding documentation, eligibility, processing and applicable charges.',
  },
  {
    title: 'Customer-Focused Approach',
    text: 'Our focus is on understanding your requirement and helping you navigate the financial process smoothly.',
  },
];

export const processSteps = [
  { step: '01', title: 'Share Your Requirement', text: 'Tell us about your financial requirement, income profile and purpose of funding.' },
  { step: '02', title: 'Eligibility Assessment', text: 'We understand your profile and explore potentially suitable financial options.' },
  { step: '03', title: 'Documentation', text: 'Our team guides you regarding the documents required for the application.' },
  { step: '04', title: 'Application & Coordination', text: 'We assist with the application process and coordinate with the relevant financial institution.' },
  { step: '05', title: 'Approval & Disbursement', text: 'Subject to lender approval, documentation and applicable terms, the loan proceeds towards sanction and disbursement.' },
];

export const loanTypes = [
  {
    title: 'Home Loan',
    summary: 'Turn your dream of owning a home into reality with suitable home loan solutions. We assist with documentation, application processing and coordination throughout the loan journey.',
    lists: [
      {
        label: 'Ideal for:',
        points: ['Purchase of a new home', 'Resale property', 'Construction of a house', 'Home renovation / improvement'],
      },
      {
        label: 'Property Types',
        points: [
          'Residential',
          'Commercial',
          'Industrial',
          'Warehouse',
          'Godown',
          'MIDC',
          'MHADA',
          'Grampanchayat',
          'Gaonthan',
          '7/12 Extract with N.A. Land',
        ],
      },
      {
        label: 'Key Programs:',
        wide: true,
        points: [
          'Banking / Banking Surrogate',
          'Income-Based Program',
          'Rental Income Program',
          'Liquid Income Program',
          'Low LTV Program',
          'GPR / Professional Program',
          'Gross Turnover Program',
          'Industry Margin Program',
          'Gross Profit Method',
        ],
      },
    ],
  },
  {
    title: 'Loan Against Property',
    summary: 'Unlock the financial value of your residential or commercial property. Loan Against Property can be considered for personal, business or other eligible financial requirements, subject to lender policies.',
    lists: [
      {
        label: 'We assist with:',
        points: ['Property assessment', 'Documentation', 'Application processing', 'Lender coordination'],
      },
      {
        label: 'Property Types',
        points: [
          'Residential',
          'Commercial',
          'Industrial',
          'Warehouse',
          'Godown',
          'MIDC',
          'MHADA',
          'Grampanchayat',
          'Gaonthan',
          '7/12 Extract with N.A. Land',
        ],
      },
      {
        label: 'Key Programs:',
        wide: true,
        points: [
          'Banking / Banking Surrogate',
          'Income-Based Program',
          'Rental Income Program',
          'Liquid Income Program',
          'Low LTV Program',
          'GPR / Professional Program',
          'Gross Turnover Program',
          'Industry Margin Program',
          'Gross Profit Method',
        ],
      },
    ],
  },
  {
    title: 'Personal Loan',
    summary: 'Get assistance in exploring personal finance options for eligible requirements such as family needs, education, medical expenses, travel, marriage or other personal commitments.',
    detail: 'We help you understand the available options and documentation requirements.',
    pointsLabel: null,
    points: ['Attractive ROI', 'Flexible Tenure', 'Quick Disbursal'],
  },
  {
    title: 'Business Loan',
    summary: 'Give your business the financial support it needs to grow. We assist business owners and self-employed professionals in exploring suitable funding solutions for:',
    lists: [
      {
        label: null,
        points: ['Business expansion', 'Working capital', 'Equipment and machinery', 'Business requirements', 'New business initiatives'],
      },
      {
        label: 'Eligible Constitutions',
        points: ['Proprietorship', 'Partnership Firm', 'LLP', 'Private Limited Companies', 'HUF - Proprietor / Partnership'],
      },
      {
        label: null,
        wide: true,
        points: ['Attractive ROI', 'Flexible Tenure', 'Quick Disbursal'],
      },
    ],
  },
  {
    title: 'Vehicle Loan',
    summary: 'Looking to purchase a new or pre-owned vehicle? We assist customers in exploring suitable vehicle finance options for eligible cars, commercial vehicles and other vehicles, subject to lender terms and conditions.',
    pointsLabel: 'Our Vehicle Loan Services:',
    points: ['New Car Purchase – Financing options for purchasing a new car.', 'Second-Hand Car Purchase – Loan options for buying a pre-owned car.', 'Balance Transfer – Assistance with transferring your existing vehicle loan from another bank to explore suitable terms and repayment options.','Commercial Vehicle Finance – Financing assistance for all types of commercial vehicles, subject to lender eligibility and terms.'],
  },
  {
    title: 'Startup Loan',
    summary: 'Planning to establish or expand a manufacturing business? H.J. Enterprises helps eligible entrepreneurs explore suitable startup and business finance options based on their business profile, experience, project details and lender requirements.',
    pointsLabel: 'Our Startup Loan Eligibility & Requirements:',
    points: ['Manufacturing Units Only – Finance assistance specifically for manufacturing businesses.',
      'Minimum 3 Years of Experience – Applicants should have at least three years of relevant business or industry experience.',
      '7-Year Financial Projection Report – A detailed financial projection report covering the upcoming seven years is required to support the business plan and loan application.',
      'Your Vision. Your Manufacturing Business. Our Financial Guidance.',
      'Loan approval is subject to lender eligibility criteria, documentation and terms and conditions.']
  },
  {
    title: 'Builder & Project Finance',
    summary: 'We assist builders and developers in exploring project finance solutions for eligible residential and commercial projects.',
    lists: [
      {
        label: 'Our support includes:',
        points: ['Project finance consultation', 'Documentation assistance', 'Financial structuring support', 'Lender coordination', 'Project-related funding requirements'],
      },
      {
        label: 'Our support includes:',
        points: [
          'Small & Mid-Sized Developers',
          'Own Land Projects',
          'Early-Stage & Last-Mile Projects',
          'Normal Income / Banking Surrogate / Project Cash Flow Assessment',
        ],
      },
      {
        label: 'Inventory Funding',
        wide: true,
        points: ['Up to ₹250 Crores', 'OC-Received / Ready Inventory', 'Builder & Developer Funding'],
      },
    ],
  },
];

export const loanFormOptions = loanTypes.map((item) => item.title);

export const insurance = {
  title: 'Insurance Solutions',
  subtitle: 'All Insurance Services Under One Platform',
  intro: 'Protect what matters to you with suitable insurance solutions.',
  assist: 'We assist customers with insurance requirements across:',
  products: ['Life Insurance', 'Health Insurance', 'Motor Insurance', 'Property Insurance', 'Other eligible insurance products'],
  objective: 'Our objective is to help you understand your available options before making a decision.',
};

export const about = {
  title: 'About H.J. Enterprises',
  body: 'H.J. Enterprises – Finance Solution is a financial services consultancy based in Goregaon West, Mumbai, providing assistance across multiple loan and insurance requirements.',
  lead: 'Led by Jitendra Shekhar Shingre, we focus on providing professional guidance, responsive service and practical financial solutions for individuals, professionals, entrepreneurs, property owners and businesses.',
  visionLabel: 'Our vision is simple:',
  vision: 'To make financial solutions simpler, more accessible and more transparent.',
};

export const advisor = {
  heading: 'Meet Your Financial Advisor',
  name: 'Jitendra Shekhar Shingre',
  role: 'Proprietor',
  bio: 'With a customer-focused approach, Jitendra Shekhar Shingre assists clients in navigating different loan and financial requirements.',
  support: 'Whether you are planning to purchase a property, expand your business, arrange funds against property, purchase a vehicle or explore insurance solutions, H.J. Enterprises is here to assist you.',
};

export const faq = [
  {
    question: 'What types of loans do you assist with?',
    answer: 'We assist with home loans, loan against property, personal loans, business loans, vehicle loans, startup loans and eligible builder/project finance requirements.',
  },
  {
    question: 'Can I apply if I am self-employed?',
    answer: 'Yes. Self-employed applicants may be eligible for various financial products depending on income, business profile, credit history, documents and lender-specific criteria.',
  },
  {
    question: 'Do you assist with property-related finance?',
    answer: 'Yes. We assist with eligible home loans, loan against property and selected property/project finance requirements.',
  },
  {
    question: 'How do I start?',
    answer: 'Simply contact us and share your requirement. Our team will understand your profile and guide you regarding the next steps and required documents.',
  },
  {
    question: 'Is loan approval guaranteed?',
    answer: 'No. Loan approval, interest rate, tenure, amount and disbursement are subject to the respective financial institution\'s eligibility criteria, policies, documentation and final approval.',
  },
];

export const testimonialImage = 'assets/images/noimage.jpg';

export const testimonials = [
  {
    id: 'mahesh-dhanawade-home-2008',
    name: 'Mahesh Dhanawade',
    designation: 'Home Loan · Seawoods · 2008',
    quote:
      'H.J. Enterprises made my first home loan journey in Seawoods smooth and stress-free. Clear guidance at every step gave me real confidence.',
  },
  {
    id: 'mahesh-dhanawade-personal-2012',
    name: 'Mahesh Dhanawade',
    designation: 'Personal Loan · 2012',
    quote:
      'When I needed a personal loan, the team understood my requirement quickly and helped me complete the process without unnecessary delays.',
  },
  {
    id: 'mahesh-dhanawade-home-2020',
    name: 'Mahesh Dhanawade',
    designation: 'Home Loan · 2020',
    quote:
      'I came back to H.J. Enterprises because of the trust built over the years. Once again, the home loan support was professional and transparent.',
  },
  {
    id: 'mahesh-dhanawade-personal-2024',
    name: 'Mahesh Dhanawade',
    designation: 'Personal Loan · 2024',
    quote:
      'For my personal loan, I received honest advice and timely follow-up. It is reassuring to work with a team that values long-term relationships.',
  },
  {
    id: 'mahesh-dhanawade-home-2026',
    name: 'Mahesh Dhanawade',
    designation: 'Home Loan · 2026',
    quote:
      'Even after many years, H.J. Enterprises continues to deliver the same quality of service. I am grateful for their consistent support.',
  },
  {
    id: 'prajakta-bhosle-lap-2020',
    name: 'Prajakta Bhosle',
    designation: 'Loan Against Property · Santacruz · 2020',
    quote:
      'They explained my loan against property options clearly and coordinated everything patiently. I felt supported from enquiry to disbursement.',
  },
  {
    id: 'ambadas-sangale-lap-2026',
    name: 'Ambadas Sangale',
    designation: 'Loan Against Property · Goregaon · 2026',
    quote:
      'H.J. Enterprises helped me unlock value from my property with transparent communication and dependable lender coordination.',
  },
  {
    id: 'deepak-jadhav-home-2026',
    name: 'Deepak Jadhav',
    designation: 'Home Loan · Vasai · 2026',
    quote:
      'Buying a home in Vasai felt much easier with their guidance. Documentation support and regular updates made the entire process comfortable.',
  },
  {
    id: 'achal-pathak-home-2026',
    name: 'Achal Pathak',
    designation: 'Home Loan · Bhyander · 2026',
    quote:
      'The team listened to my goals and suggested a suitable home loan path. Professional, responsive and genuinely customer-focused.',
  },
  {
    id: 'kunal-gupta-personal-2026',
    name: 'Kunal Gupta',
    designation: 'Personal Loan · Mira Road · 2026',
    quote:
      'I needed funds on short notice and H.J. Enterprises guided me through a personal loan option that fit my profile. Quick and hassle-free experience.',
  },
  {
    id: 'sumit-gupta-ca-2006',
    name: 'Sumit Gupta',
    designation: 'Chartered Accountant · Borivali · 2006',
    quote:
      'Our association since 2006 has been built on trust and professionalism. I am happy to work alongside a team that puts clients first.',
  },
  {
    id: 'khem-singh-bhandari-2002',
    name: 'Khem Singh Bhandari',
    designation: 'Channel Partner · Kandivali · 2002',
    quote:
      'As a channel partner, I value how H.J. Enterprises treats customers and partners with respect. It has been a rewarding long-term association.',
  },
  {
    id: 'dattatray-naik-2000',
    name: 'Dattatray Naik',
    designation: 'Real Estate Agent · Khar · 2000',
    quote:
      'Working as a connector for so many years, I have seen how sincerely the team supports clients. That is why I continue to refer people with confidence.',
  },
  {
    id: 'kiran-pawar-2020',
    name: 'Kiran Pawar',
    designation: 'Banker · Vikroli · 2020',
    quote:
      'Coordinating business and personal loan files with H.J. Enterprises is always organised and professional. Clients receive clear, timely support.',
  },
  {
    id: 'sushil-singh-2004',
    name: 'Sushil Singh',
    designation: 'Banker · Andheri · 2004',
    quote:
      'Over the years, I have appreciated their transparent approach and smooth file handling. It makes banking coordination easier for everyone involved.',
  },
  {
    id: 'chandrakant-aywale-2024',
    name: 'Chandrakant Aywale',
    designation: 'Banker · Thane · 2024',
    quote:
      'Home loan and loan against property cases are handled with care and accuracy. The team maintains clear communication throughout the process.',
  },
  {
    id: 'pooja-singh-2023',
    name: 'Pooja Singh',
    designation: 'Real Estate · Thane · 2023',
    quote:
      'As a channel partner, I am glad to work with a team that values ethics and client satisfaction. Referrals feel safe when H.J. Enterprises is involved.',
  },
  {
    id: 'bharti-bhodhare-home-2026',
    name: 'Bharati Bhodhare',
    designation: 'Home Loan · Matunga · 2026',
    quote:
      'From the first discussion to final sanction, I felt heard and guided properly. H.J. Enterprises made my home loan journey positive and reassuring.',
  },
  {
    id: 'harsita-nikam-2025',
    name: 'Harsita Nikam',
    designation: 'Banker · Kandivali · 2025',
    quote:
      'Loan against property files are managed with attention to detail. I appreciate the team’s professionalism and commitment to getting things done right.',
  },
  {
    id: 'rajesh-teli-2019',
    name: 'Rajesh Teli',
    designation: 'Banker · Borivali · 2019',
    quote:
      'Whether it is a home loan or LAP file, coordination is smooth and clients are kept informed. A dependable partner to work with.',
  },
  {
    id: 'rusikesh-shinde-2021',
    name: 'Rusikesh Shinde',
    designation: 'Banker · Andheri · 2021',
    quote:
      'I have seen how patiently the team supports customers through documentation and lender follow-ups. That builds real trust on both sides.',
  },
  {
    id: 'bhupendra-rana-home-2026',
    name: 'Bhupendra Rana',
    designation: 'Home Loan · Jogeshwari · 2026',
    quote:
      'H.J. Enterprises helped me understand my home loan options without pressure. The process was transparent and the support was excellent.',
  },
  {
    id: 'dilip-khambati-personal-2016',
    name: 'Dilip Khambati',
    designation: 'Personal Loan · Malad · 2016',
    quote:
      'My personal loan was arranged with clear explanations and no confusion. I would gladly recommend their services to friends and family.',
  },
  {
    id: 'divesh-solanki-lap-2022',
    name: 'Divesh Solanki',
    designation: 'Loan Against Property · Dahisar · 2022',
    quote:
      'They guided me on loan against property with practical advice and steady follow-up. I am satisfied with the overall experience and outcome.',
  },
  {
    id: 'vivek-tiwari-2008',
    name: 'Vivek Tiwari',
    designation: 'Advocate · Andheri · 2008',
    quote:
      'Documentation and agreements are handled with care and clarity. It is a pleasure working with a team that respects compliance and client interests.',
  },
  {
    id: 'mukesh-rane-it',
    name: 'Mukesh Rane',
    designation: 'Income Tax Filing · Kandivali',
    quote:
      'For over six years, income tax filing support has been reliable and well organised. I appreciate the consistency and professional approach.',
  },
  {
    id: 'sudhashankar-2018',
    name: 'Sudhashankar',
    designation: 'ICICI Banker · Malad · 2018',
    quote:
      'DSC and related banking coordination with H.J. Enterprises is efficient and dependable. Clients benefit from a team that stays proactive.',
  },
];

export const mutualFundHelp = {
  title: 'How H.J. Enterprises Helps You Invest in the Right Mutual Funds',
  intro: 'At H.J. Enterprises, we believe that successful investing starts with the right guidance and a clear understanding of your financial goals. Whether you are planning for long-term wealth creation, your children\'s education, retirement, or future financial security, we help you explore mutual fund investment options that align with your objectives, investment horizon, and risk appetite.',
  approachTitle: 'Our Approach to Mutual Fund Investments',
  steps: [
    {
      title: 'Understand Your Financial Goals',
      text: 'We help you identify your investment objectives, whether you want to build wealth over time, save for a major milestone, or plan for your future.',
      image: 'assets/images/site/Understand your fin goals.jpg',
    },
    {
      title: 'Explore Suitable Investment Options',
      text: 'We help you understand different categories of mutual funds, including equity, debt, hybrid, and other schemes, so you can make informed investment decisions.',
      image: 'assets/images/site/Explore sutable inv options.jpg',
    },
    {
      title: 'Invest According to Your Risk Profile',
      text: 'Every investor has different financial needs and risk tolerance. We help you understand the risks associated with different mutual fund categories before choosing suitable options.',
      image: 'assets/images/site/invest according to profile risk.jpg',
    },
    {
      title: 'Plan Your Investments Wisely',
      text: 'Whether you prefer a Systematic Investment Plan (SIP) or a lump-sum investment, we help you understand the available approaches and how they may fit your financial plans.',
      image: 'assets/images/site/plan your investment wisly.jpg',
    },
    {
      title: 'Focus on Long-Term Wealth Creation',
      text: 'We encourage disciplined investing and a goal-oriented approach to help you work towards your long-term financial aspirations.',
      image: 'assets/images/site/focus on longterm goal creation.jpg',
    },
    {
      title: 'Review and Refine Your Investment Strategy',
      text: 'As your financial goals and circumstances change, reviewing your investments can help you determine whether your portfolio remains aligned with your objectives.',
      image: 'assets/images/site/review and refine your investment.jpg',
    },
  ],
  closerTitle: 'Start Your Investment Journey with Confidence',
  closer: 'At H.J. Enterprises, our aim is to make mutual fund investing easier to understand through personalized guidance and transparent communication. Connect with us to explore investment options suited to your financial goals.',
  disclaimer: 'Mutual fund investments are subject to market risks. Please read all scheme-related documents carefully before investing. Returns are not guaranteed.',
};

export const whyChooseMutual = {
  title: 'Why Choose H.J. Enterprises?',
  intro: [
    'At H.J. Enterprises, we believe that the right financial guidance can help turn your dreams into reality. Whether you are planning to buy your dream home, expand your business, manage personal expenses, or make the most of your property, we help you explore financial solutions suited to your needs.',
    'Our focus is on making your financial journey simpler through personalized guidance, transparent communication, and support at every step.',
  ],
  reasonsTitle: 'Why Choose Us?',
  reasons: [
    {
      title: 'Personalized Financial Solutions',
      text: 'We understand that every financial goal is unique. We help you explore suitable loan and financial options based on your requirements and eligibility.',
      image: 'assets/images/site/personaliz-fin-soln.jpg',
    },
    {
      title: 'Expert Guidance',
      text: 'Our team helps you understand available options, documentation requirements, and the application process so you can make informed financial decisions.',
      image: 'assets/images/site/expert-guidence.jpg',
    },
    {
      title: 'Transparent Process',
      text: 'We believe in clear communication, honest guidance, and transparency throughout your financial journey.',
      image: 'assets/images/site/transparent-process.jpg',
    },
    {
      title: 'Wide Range of Financial Services',
      text: 'From home loans and loan against property to business loans, personal loans, vehicle loans, and insurance solutions, we help you explore options under one roof.',
      image: 'assets/images/site/wide-range-of-fin-ser.jpg',
    },
    {
      title: 'Hassle-Free Assistance',
      text: 'We aim to simplify the paperwork and application process by guiding you through the necessary steps.',
      image: 'assets/images/site/hassle-free-assistance.jpg',
    },
    {
      title: 'Your Goals, Our Priority',
      text: 'Your financial aspirations matter to us. We strive to build long-term relationships through reliable service, personalized attention, and a customer-first approach.',
      image: 'assets/images/site/your-goal-our-priority.jpg',
    },
  ],
  closerTitle: 'Let’s Build Your Financial Future Together',
  closer: 'At H.J. Enterprises, we are committed to helping you move forward with confidence. Connect with us today to explore financial solutions that align with your goals.',
};

export const contactPage = {
  title: 'Contact Us',
  heading: "Let's Discuss Your Financial Requirement",
  looking: 'Looking for the right financial solution?',
  talk: 'Talk to H.J. Enterprises today.',
};

export const disclaimer = 'H.J. Enterprises acts as a financial services facilitator/consultant and does not guarantee loan approval, sanction, interest rate or disbursement. All financial products are subject to the respective lender\'s eligibility criteria, policies, documentation, applicable charges and final approval. Insurance products are subject to the terms and conditions of the respective insurer.';
